import { FileWarning } from "lucide-react";
import Seo from "@/components/Seo";

export default function Privacy() {
  return (
    <>
      <Seo
        title="Privacy | Reliance Motor Claims Recovery"
        description="How Reliance Motor Claims Recovery collects, uses and protects your personal information."
        path="/privacy"
      />

      <section className="bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20">
          <p className="font-saira font-semibold text-xs sm:text-sm tracking-widest uppercase text-steel border-l-4 border-road pl-3">
            Privacy
          </p>
          <h1 className="mt-4 text-4xl sm:text-5xl font-bold tracking-tight text-ink">
            Privacy policy
          </h1>

          <div
            className="mt-8 flex items-start gap-3 bg-[#FDF3E3] border-l-4 border-road rounded p-4"
            data-testid="privacy-draft-notice"
          >
            <FileWarning className="size-5 mt-0.5 shrink-0 text-ink" aria-hidden="true" />
            <p className="text-sm font-semibold text-ink">
              Draft – to be reviewed. This page is a draft summary and has not yet been
              legally reviewed.
            </p>
          </div>

          <div className="mt-10 space-y-8 text-base sm:text-lg leading-relaxed text-steel">
            <div>
              <h2 className="font-saira font-semibold text-xl sm:text-2xl text-ink">
                What we collect
              </h2>
              <p className="mt-3">
                When you make a claim or contact us, we collect personal information such as
                your contact details, driver licence details, details about the accident, and
                photos you provide of the vehicles and scene.
              </p>
            </div>

            <div>
              <h2 className="font-saira font-semibold text-xl sm:text-2xl text-ink">
                Why we collect it
              </h2>
              <p className="mt-3">
                We collect this information for one purpose only: to manage your claim. That
                includes lodging the claim, dealing with the at-fault party's insurer,
                arranging your replacement vehicle, storage and repairs, and recovering your
                losses.
              </p>
            </div>

            <div>
              <h2 className="font-saira font-semibold text-xl sm:text-2xl text-ink">
                Who we share it with
              </h2>
              <p className="mt-3">
                We share your information only with the parties needed to manage your claim –
                for example insurers, repairers and legal representatives. We do not sell your
                information or share it for marketing.
              </p>
            </div>

            <div>
              <h2 className="font-saira font-semibold text-xl sm:text-2xl text-ink">
                How we store it
              </h2>
              <p className="mt-3">
                Your information is stored securely and access is limited to the people
                managing your claim.
              </p>
            </div>

            <div>
              <h2 className="font-saira font-semibold text-xl sm:text-2xl text-ink">
                Access and corrections
              </h2>
              <p className="mt-3">
                You can ask to see the personal information we hold about you, or ask us to
                correct it, at any time. Contact us at{" "}
                <a
                  href="mailto:claims@reliancemotorclaims.com.au"
                  className="font-semibold text-ink underline decoration-road decoration-2 underline-offset-4 break-all"
                  data-testid="privacy-email-link"
                >
                  claims@reliancemotorclaims.com.au
                </a>{" "}
                or call{" "}
                <a
                  href="tel:1800957474"
                  className="font-semibold text-ink underline decoration-road decoration-2 underline-offset-4"
                  data-testid="privacy-phone-link"
                >
                  1800 957 474
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
